<script setup>
import { AccordionContent, useForwardProps } from "reka-ui";

const props = defineProps({
  forceMount: { type: Boolean, default: false },
  asChild: { type: Boolean, default: false },
  as: { type: [String, Object], default: "div" },
});

const forwarded = useForwardProps(props);
</script>

<template>
  <AccordionContent v-bind="forwarded" class="accordion-content">
    <div class="accordion-content-inner">
      <slot />
    </div>
  </AccordionContent>
</template>

<style lang="scss" scoped>
.accordion-content {
  overflow: hidden;

  &[data-state="open"] {
    animation: accordion-down 0.2s ease-out;
  }

  &[data-state="closed"] {
    animation: accordion-up 0.2s ease-out;
  }
}

@keyframes accordion-down {
  from {
    height: 0;
  }

  to {
    height: var(--reka-accordion-content-height);
  }
}

@keyframes accordion-up {
  from {
    height: var(--reka-accordion-content-height);
  }

  to {
    height: 0;
  }
}
</style>
